<template>
  <v-footer absolute class="bg-secondary">
    <v-row
      style="width: 50%; margin: 0 auto; text-align: center;"
      class="justify-center"
    >
      <v-col>
        <div v-ripple>
          <span class="snsbutton fade">
            <!-- twitter -->
            <a
              href="http://twitter.com/share?&url=http://d-mebius.com/elminages/"
              rel="nofollow"
            >
              <picture>
                <souce
                  srcset="../assets/icon_twitter.webp"
                  type="image/webp"
                  width="64"
                  height="64"
                />
                <img
                  src="../assets/icon_twitter.png"
                  alt="ツイート"
                  width="64"
                  height="64"
                />
              </picture>
            </a>
          </span>
        </div>
      </v-col>
      <v-col>
        <div v-ripple>
          <span class="snsbutton">
            <!-- facebook -->
            <a
              href="http://www.facebook.com/share.php?u=http://d-mebius.com/elminages/"
              onclick="window.open(encodeURI(decodeURI(this.href)), 'FBwindow', 'width=554, height=470, menubar=no, toolbar=no, scrollbars=yes'); return false;"
              rel="nofollow"
            >
              <picture>
                <souce
                  srcset="../assets/icon_fb.webp"
                  type="image/webp"
                  width="64"
                  height="64"
                />
                <img src="../assets/icon_fb.png" width="64" height="64" />
              </picture>
            </a>
          </span>
        </div>
      </v-col>

      <!-- end .sns -->
    </v-row>
    <v-row
      style="width: 50%; margin: 0 auto; text-align: center;"
      align="center"
    >
      <v-col>
        <div>
          <picture class="ma-5">
            <source
              srcset="../assets/icon_switch.webp"
              type="image/webp"
              width="64"
              height="64"
            />
            <img src="../assets/icon_switch.png" width="64" height="64" />
          </picture>
        </div>
      </v-col>
      <v-col>
        <div v-ripple>
          <a href="http://d-mebius.com/">
            <picture class="ma-5">
              <source
                srcset="../assets/logo_mebius.webp"
                type="image/webp"
                width="175"
                height="43"
              />
              <img src="../assets/logo_mebius.png" width="175" height="43" />
            </picture>
          </a>
        </div>
      </v-col>

      <v-col>
          <!-- <a href="https://takiya.info/"> -->
            <picture class="ma-5">
              <source
                srcset="../assets/starfish_logo.webp"
                type="image/webp"
                width="160"
                height="50"
              />
              <img src="../assets/starfish_logo.png" />
            </picture>
          <!-- </a> -->

      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="copyright">
          <div class="ma-auto text-center">
            <p>
              &copy; STARFISH-SD INC. &copy; mebius.
            </p>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-footer>
</template>

<style scoped>
  footer {
    width: 100%;
    display: block;
    position: relative;
    padding-top: 30px;
  }
</style>
